import { useCallback } from 'react';

import { useAppDispatch } from '@/Application/Hooks/Redux';

import { SET_GLOBAL_TOAST } from '../store';

const useToast = () => {
  const dispatch = useAppDispatch();

  const toast = useCallback(
    (title: string, subTitle: string, variant: string) =>
      dispatch({
        type: SET_GLOBAL_TOAST,
        payload: { title, subTitle, variant, isOpen: true }
      }),
    [dispatch]
  );

  return toast;
};

export default useToast;
